module.exports = __webpack_public_path__ + "media/entities/1305-6a66dfa7.png";